<template>
    <div>
        <Mypost  :services="services"/>
        <DropdownMyadds  :services="services"/>
    </div>
</template>
<script>
import Mypost from './Mypost.vue';
import DropdownMyadds from './DropdownMyadds.vue';
import { fetchServices, loadServiceImages } from "@/services/serviceLoader.js";

export default {
   components: {
    Mypost,
    DropdownMyadds,
  },
    name: "MyAdds",
    data() {
    return {
      services: [],
      loading: false,
      defaultImage: "../icons/Header.png",
      userId:localStorage.getItem("userid"),
    };
  },
 async mounted() {

    console.log("userId displaying from --->",this.userId);
    let services = await fetchServices(this.userId, this.defaultImage);

    console.log(services)
    this.services = services;

    const updated = await loadServiceImages(services, this.defaultImage);

    this.services = updated;
  },
    components:{
        Mypost
    }
}
</script>
<style scoped>

</style>